import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-privacy-agreement-popup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './privacy-agreement-popup.component.html',
  styleUrls: ['./privacy-agreement-popup.component.css']
})
export class PrivacyAgreementPopupComponent {
  @Input() isVisible = false;
  @Output() agreementAccepted = new EventEmitter<void>();
  @Output() agreementRejected = new EventEmitter<void>();

  privacyForm: FormGroup;
  isLoading = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    this.privacyForm = this.fb.group({
      acceptPrivacyAgreement: [false, Validators.requiredTrue]
    });
  }

  onAccept(): void {
    if (this.privacyForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';

      const request = {
        acceptPrivacyAgreement: true,
        privacyAgreementVersion: '1.0'
      };

      this.authService.acceptPrivacyAgreement(request.acceptPrivacyAgreement, request.privacyAgreementVersion)
        .subscribe({
          next: (response: any) => {
            this.isLoading = false;
            if (response.success) {
              this.agreementAccepted.emit();
            } else {
              this.errorMessage = response.message || 'Failed to accept privacy agreement';
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.errorMessage = error.error?.message || 'Failed to accept privacy agreement';
          }
        });
    } else {
      this.privacyForm.markAllAsTouched();
    }
  }

  onReject(): void {
    this.agreementRejected.emit();
  }

  closePopup(): void {
    // Only allow closing if privacy agreement is not required
    if (!this.isRequired) {
      this.agreementRejected.emit();
    }
  }

  get isRequired(): boolean {
    // This would be set based on whether the user was created by admin
    return true; // For now, always required
  }

  getCurrentDate(): string {
    return new Date().toLocaleDateString();
  }
}
